import { createContext } from 'react';

import type { MyWorkspaceStore } from '@core/store';

export const MyWorkspaceStoreContext = createContext<MyWorkspaceStore>(null!);
